import { render, staticRenderFns } from "./RxDialog.vue?vue&type=template&id=3e96a4a8"
import script from "./RxDialog.vue?vue&type=script&lang=js"
export * from "./RxDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports